module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-campaigns-e78473d318290d3bd14eb005bdf44e1f.svg";